import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'logs',
            name: 'log',
            class: 'App\\Models\\Log'
        }
    }
}